import { useEffect, useMemo, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { CharlesTitle } from '@abm-international/react-components';
import api from '../../../libraries/api';
import './OverviewPOM.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';


export const OverviewPOM = () => {
	const [poms, setPoms] = useState<any[]>([]);
	const [pomsFilled, setPomsFilled] = useState<any>([]);
	const [pomId, setPomId] = useState<string>('');

	const history = useHistory();

	useEffect(() => {
		(async () => {
			const _poms: any[] = await api.getPoms();
			setPoms(_poms);
		})();
	}, []);

	useEffect(() => {
		if (!pomId) {
			return;
		}

		(async () => {
			const _pom: any[] = await api.getPomsFilled(pomId);
			setPomsFilled(_pom);
		})();
	}, [pomId]);


	const pom = useMemo(() => {
		if (!pomId) return undefined;
		return poms.find(pom => pom.pmt_tmplid === pomId);
	}, [pomId]);

	return (
		<>
			{/* <CharlesTitle alt>POM</CharlesTitle> */}
			<h1 className={'CharlesTitle'} style={{ backgroundColor: '#F4F4F4', padding: '1.5rem 4rem', borderRadius: '1rem' }}>
				<span >
                    POM
				</span>
			</h1>

			<div className='overview'>
				<ol className="poms">
					{poms?.map((pom, index) => {
						return (
							<li
								key={index}
								value={pom.pmt_tmplid}
								className={pomId === pom.pmt_tmplid ? 'active' : ''}
								onClick={() => setPomId(pom.pmt_tmplid)}
							>
								{/* <span>{pom.pmt_tmplid}</span> */}
								<span>{pom.pmt_tit}</span>
							</li>
						);
					})}
				</ol>

				{pom && <aside className='pom'>
					<h3>{pom.pmt_tmplid}. {pom.pmt_tit}</h3>

					<Link to={`/pom/${pomId}`} className='new'>&rarr; Nieuw POM formulier</Link>

					<ul>
						{pomsFilled.map((pof: any, i: number) => {
							return (
								<li key={i}>
									<Link to={`/pom/${pomId}?id=${pof.pmi_guid}`}>
										<div>
											<span style={{ color: '#6C757D', fontWeight: '600' }}>{new Date(pof.pmi_dtc).toLocaleDateString('Nl-BE')} </span>
											{pof.pmi_oms && <span>{pof.pmi_oms} </span>}
										</div>

										<span><FontAwesomeIcon icon={faInfoCircle} /></span></Link>
								</li>
							);
						})}
					</ul>
				</aside>}
			</div>
		</>
	);
};
